import { reduce } from "et3-type-guards";
import React from "react";
import { E_MESSAGE_DELETION_STATUS, TMessage } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import MessageReactions from "../../../../message-reactions";
import { REACTION_DIVIDER_COLOR } from "../../../../message-reactions/reaction-constants";
import MessageType from "./MessageType";
import MessageHiddenIndicator from "./MessageHiddenIndicator";

const Message = withLiteObserverAndTheme<{
  message: TMessage;
  userId: number;
  reporterGender: string;
  reportedGender: string;
}>((props) => {
  const {
    theme: { colors },
    userId,
    reporterGender,
    reportedGender
  } = props;
  const message = reduce(() => props.message, {
    sentOn: "",
    message: "",
    senderId: 0,
    messageId: 0,
    messageType: "text",
    recipientId: 0,
    messageObject: {
      message: "",
      messageType: "picture"
    },
    isDeleted: E_MESSAGE_DELETION_STATUS.NOT_DELETED,
    deletedOn: "",
    reactions: [],
    hasReactionHistory: false
  });
  const getMessageStyle = () => {
    if (message.senderId === userId) {
      return colors.all.blue;
    } else {
      return colors.all.green;
    }
  };
  const getMessagePosition = () => {
    if (message.senderId === userId) return "flex-start";
    else return "flex-end";
  };
  const isReporterMessage = message.senderId === userId;
  // The reporter and the reported are the only two people in the conversation,
  // so the message sender's gender is one of the two the report already carries.
  const messageSenderGender = isReporterMessage
    ? reporterGender
    : reportedGender;
  const hasReactionFooter =
    reduce(() => message.reactions.length, 0) > 0 ||
    reduce(() => message.hasReactionHistory, false);

  const bubble = (
    <ET3Div
      isScrollable={false}
      withShadow={false}
      isExtendable={true}
      height={0}
      width={535}
      color={getMessageStyle()}
      fDirection="column"
      justifyContent={getMessagePosition()}
      alignItems={"flex-start"}
      style={{
        borderRadius: 10,
        padding: 5
      }}
      onClick={() => {}}
    >
      <MessageType messages={message} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={11}
        text={message.sentOn}
        isSpan={false}
        color={colors.all.white}
        style={{}}
      />
      {hasReactionFooter ? (
        <React.Fragment>
          <ET3Div
            isScrollable={false}
            withShadow={false}
            isExtendable={false}
            height={1}
            width={0}
            color={REACTION_DIVIDER_COLOR}
            fDirection="row"
            justifyContent="center"
            alignItems="center"
            style={{ width: "100%", minHeight: 1 }}
            onClick={() => {}}
          />
          <MessageReactions
            messageId={message.messageId}
            messageSenderId={message.senderId}
            messageSenderGender={messageSenderGender}
            reactions={message.reactions}
            hasReactionHistory={message.hasReactionHistory}
            showLastReactionTime={true}
            contentColor={colors.all.white}
          />
        </React.Fragment>
      ) : null}
    </ET3Div>
  );

  const hiddenIndicator = (
    <MessageHiddenIndicator
      isDeleted={message.isDeleted}
      deletedOn={message.deletedOn}
    />
  );

  return (
    <ET3Div
      isScrollable={false}
      withShadow={false}
      isExtendable={true}
      height={150}
      width={1064}
      color={colors.all.transparent}
      fDirection="row"
      justifyContent={getMessagePosition()}
      alignItems={"center"}
      style={{ gap: "10px", flexShrink: 0 }}
      onClick={() => {}}
    >
      {isReporterMessage ? (
        <>
          {bubble}
          {hiddenIndicator}
        </>
      ) : (
        <>
          {hiddenIndicator}
          {bubble}
        </>
      )}
    </ET3Div>
  );
});
export default Message;
